import { useBookingQuery } from '../queries/useBookingQueries';
import { getLocalTimezone } from '@/lib';

interface UseBookingParams {
    bookingId: string;
    timezone?: string;
}

/**
 * Hook that orchestrates booking query and returns formatted data
 */
export function useBooking({ bookingId, timezone = getLocalTimezone() }: UseBookingParams) {
    const query = useBookingQuery({ bookingId, timezone });

    return {
        booking: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error,
        refetch: query.refetch,
    };
}
